import { PropertyCtaStatechartService } from 'common/module/property-cta/statechart/service';
import { PropertyCtaStatsStore } from 'common/module/property-cta/stats/store';
import { StatsCtaPropertyService } from 'common/service/stats-cta-property/service';

const service = new PropertyCtaStatsStore(PropertyCtaStatechartService(), StatsCtaPropertyService());

service.initialize();

export const PropertyCtaStatsService = () => service;
